import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import createGesture from './gesture';

interface Scroller {
  isScrolling: boolean;
}

interface SwipeMenuList {
  openIndex: number;
}

interface TouchableProps {
  scroller?: Scroller;
  swipeMenuList?: SwipeMenuList;
  activeClass?: string;
  onTap: (target: EventTarget) => void;
  onTouchStart: (evt: React.TouchEvent) => void;
  disabled?: boolean;
  children: React.ReactNode;
}

const Touchable = forwardRef<HTMLElement, TouchableProps>(({
  scroller,
  swipeMenuList,
  activeClass,
  onTap,
  onTouchStart,
  disabled,
  children
}, ref) => {
  const componentRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => componentRef.current as HTMLElement);

  useEffect(() => {
    const gesture = createGesture({
      domRef: componentRef,
      scroller,
      swipeMenuList,
      activeClass,
      onTap,
      onTouchStart,
      disabled
    });

    const domNode = componentRef.current;
    if (!domNode) return;

    domNode.addEventListener('touchstart', gesture.onTouchStart);
    domNode.addEventListener('touchmove', gesture.onTouchMove);
    domNode.addEventListener('touchend', gesture.onTouchEnd);
    domNode.addEventListener('touchcancel', gesture.onTouchCancel);

    return () => {
      domNode.removeEventListener('touchstart', gesture.onTouchStart);
      domNode.removeEventListener('touchmove', gesture.onTouchMove);
      domNode.removeEventListener('touchend', gesture.onTouchEnd);
      domNode.removeEventListener('touchcancel', gesture.onTouchCancel);
    };
  }, [scroller, swipeMenuList, activeClass, onTap, onTouchStart, disabled]);

  return <div ref={componentRef}>{children}</div>;
});

export default Touchable;